import styled from '@emotion/styled'
import {
  Icon,
  IconButton,
  Paper,
  Theme,
  Typography,
  theme,
} from '@yuno/design-system-web'

const PaperStyled = styled(Paper)<{ component: string; theme?: Theme }>`
  border-radius: 4px;
  padding: 2px 4px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  width: 100% !important;
  border: solid 1px #eceff2;
  background: #fcfcff;
  min-height: unset !important;
  margin-bottom: 20px;
`

const IconButtonStyled = styled(IconButton)(({ theme }: { theme?: Theme }) => ({
  color: `${theme.palette.vivid.brand}`,
  float: 'right',
  positions: 'relative',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}))

const TypographyStyled = styled(Typography)<{ theme?: Theme }>`
  width: 90%;
  padding: 0 20px;
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
`
const TypographyViewAll = styled(Typography)<{ theme?: Theme }>`
  margin-right: 10px;
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
`

export const InputIcon = ({
  placeholder = 'Find your reports here',
  onClick,
  viewAllLabel = 'View all',
}) => {
  return (
    <PaperStyled component="form">
      <TypographyStyled>{placeholder}</TypographyStyled>
      <IconButtonStyled
        onClick={onClick}
        type="button"
        sx={{ p: '10px' }}
        aria-label="search"
      >
        <TypographyViewAll>{viewAllLabel}</TypographyViewAll>
        <Icon name="ArrowRight" size="17px" />
      </IconButtonStyled>
    </PaperStyled>
  )
}
